import React from "react";
import PropTypes from "prop-types";
import { Fade } from "components/Animations";

const propTypes = {
  on: PropTypes.bool,
  large: PropTypes.bool,
  fixed: PropTypes.bool,
  center: PropTypes.bool,
  absolute: PropTypes.bool,
  timeout: PropTypes.number,
  top: PropTypes.number,
  style: PropTypes.object,
  innerClassName: PropTypes.string,
};

const Loader = ({
  on,
  large,
  fixed,
  absolute,
  timeout = 200,
  style,
  center,
  top,
  innerClassName = "",
}) => {
  if (on === false) return null;
  const styles = { position: "static" };
  if (fixed) styles.position = "fixed";
  if (absolute) styles.position = "absolute";
  if (center) {
    styles.display = "block";
    styles.margin = "0 auto";
  }
  if (top) styles.marginTop = top;

  return (
    <Fade appear={true} in={true} timeout={timeout} style={style}>
      <div className={`loader ${large ? "loader_large" : ""} ${innerClassName}`} style={styles} />
    </Fade>
  );
};

Loader.propTypes = propTypes;
export default Loader;



// WEBPACK FOOTER //
// ./src/components/ui/Loader.jsx